import React, { createContext, useContext, useEffect, useState } from 'react';
import { User, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase';

interface FirebaseUserContextValue {
    user: User | null;
    isLoading: boolean;
}

const FirebaseUserContext = createContext<FirebaseUserContextValue | undefined>(undefined);

export const FirebaseUserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser);
            setIsLoading(false);
        });
        return unsubscribe;
    }, []);

    return (
        <FirebaseUserContext.Provider value={{ user, isLoading }}>
            {children}
        </FirebaseUserContext.Provider>
    );
};

export const useFirebaseUser = (): FirebaseUserContextValue => {
    const context = useContext(FirebaseUserContext);
    if (!context) {
        throw new Error('useFirebaseUser must be used within a FirebaseUserProvider');
    }
    return context;
};